import { Link } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import Seo from "@/components/base/Seo";
import { faqItems } from "@/mocks/faq";

export default function FaqPage() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://panelpal.github.io/" },
        { "@type": "ListItem", position: 2, name: "常见问题", item: "https://panelpal.github.io/faq" },
      ],
    },
  ];

  return (
    <MainLayout>
      <Seo
        title="常见问题 - 歪歪漫画网"
        description="歪歪漫画网常见问题解答：如何免费看漫画、漫画分类大全包含哪些题材、人气排行多久更新、如何判断新作是否值得追等阅读常见疑问。"
        keywords="歪歪漫画网,常见问题,免费看漫画,漫画分类,人气排行说明"
        canonical="/faq"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200/70 bg-background-100">
        <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
          <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">常见问题</span>
          </nav>
          <div className="mt-6">
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-question-line" /> 帮助中心
            </span>
            <h1 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
              关于免费阅读、漫画分类大全、人气排行与热门榜单、新作与完结作品等问题，这里都有答案。如果还有疑问，欢迎随时联系我们。
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="space-y-3">
          {faqItems.map((item) => (
            <div key={item.q} className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
              <h2 className="text-base font-semibold text-foreground-950 md:text-lg">{item.q}</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.a}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl bg-gradient-to-r from-primary-500 to-secondary-500 px-6 py-8 text-center sm:flex-row sm:text-left">
          <div>
            <h2 className="font-heading text-xl text-background-50">没找到你想要的答案？</h2>
            <p className="mt-1 text-sm text-background-50/90">欢迎通过邮件联系我们，我们会尽快为你解答。</p>
          </div>
          <a
            href="mailto:contact@waiwaimanga.com"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-mail-line" /> 联系我们
          </a>
        </div>
      </section>
    </MainLayout>
  );
}